import React, {useState, useEffect} from 'react';
import * as Icons from 'react-feather';
import {useList} from 'store/list'

import Loading from 'components/Loading'
import ListSearch from 'components/list/ListSearch'
import ListPagination from 'components/list/ListPagination'
import Add from './Add'

import {handleSuccessMessages} from "store/auth";

import { toJalali } from "lib/helpers";
export default function Promotions() {
   const path = {
      baseRoute: '/panel/promotions',
      aliasName: 'اطلاع رسانی',
      type: 'Promotion',
   };
   const {dispatch, clear, getList, list, load, create, update, quickUpdate, remove, listSearch, from, to, total} = useList();
   
   const [showAdd, setShowAdd] = useState(false);
   const [showEdit, setShowEdit] = useState(false);
   const [showDelete, setShowDelete] = useState(false);
   const [showResetPassword, setShowResetPassword] = useState(false);
   const [item, setItem] = useState(false);
   
   const ports={
      SMS:'sms',
      EMAIL:'email',
      SANDBOXSMS:'test sms',
      SANDBOXMAIL:'test mail',
   }
   useEffect(() => {
      dispatch(getList(path));
   
      return () => {
         dispatch(clear())
      }
   }, []);

   return (
      <>
         <Add title="اطلاع ارسانی جدید" show={showAdd} close={() => {
            setShowAdd(false)
         }} submit={(values) => {
            dispatch(create(path, values, () => {
               handleSuccessMessages("اطلاع رسانی در صف ارسال قرار گرفت")
               dispatch(getList(path))
            }))
         }}/>
        
         
         <div className="content" style={{marginBottom: 80}}>

            <h2 className="intro-y text-lg font-medium mt-10">
               اطلاع رسانی ها
            </h2>
            <div className="grid grid-cols-12 gap-6 mt-5">
               <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
                  <button onClick={() => {
                     setShowAdd(true)
                  }} className="btn btn-primary shadow-md mr-2">اطلاع رسانی جدید
                  </button>
                  {load &&
                  <div className="hidden md:block mx-auto text-gray-600 text-white">در حال بارگذاری</div>}
                  {!load &&
                  <div className="hidden md:block mx-auto text-gray-600 text-white">
                     {`نمایش ${from} تا ${to} از ${total}`}
                  </div>}
                  <ListSearch search={(key) => {
                     dispatch(listSearch(path, key))
                  }}/>
               </div>

               <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report -mt-2">
                     <thead>
                     <tr>
                        <th className="whitespace-nowrap text-center">شناسه</th>
                        <th className="whitespace-nowrap text-center">عنوان</th>
                        <th className="whitespace-nowrap text-center">پورت ارسال</th>
                        
                        <th className="whitespace-nowrap text-center">تاریخ</th>
                        
                     </tr>
                     </thead>
                     {load && <Loading/>}
                     {list && !list.length > 0 && <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>}
                     <tbody>
                     {!load && list && list.length > 0 && list.map((item) => (
                        <tr className="intro-x">
                           <td className="w-16 text-center">
                              {item.id}
                           </td>
                        
                           <td>
                              <p className="font-medium whitespace-nowrap text-center">{item.subject}</p>
                           </td>

                           <td>
                              <p className="font-medium whitespace-nowrap text-center">{ports[item.port]}</p>
                           </td>
                           <td>
                              <p className="font-medium whitespace-nowrap text-center">    {toJalali(item.created_at, "jYYYY-jMM-jDD hh:mm")}</p>
                           </td>
                           
                          
                         
                        </tr>))}
                     </tbody>
                  </table>
               </div>
               <ListPagination getList={(page, perPage) => {
                  dispatch(getList(path, page, perPage))
               }}/>
            </div>
         </div>
      </>
   );
}
